document.addEventListener("DOMContentLoaded", () => {
    const quickMenu = document.querySelector('[data-quick-menu]');
    const productCategorySingle = document.querySelector('#product-category-single');

    if (!quickMenu && productCategorySingle) {
		productCategorySingle.classList.add('no-quicklinks');
	}
});
